import { useMutation } from 'react-query';

import { generateApiKey } from 'RestAPIs/admin';

import { showErrorSnackbar } from 'components/shared/Snackbar';

export const useGenerateAPIKey = () => {
  const { mutateAsync, isLoading } = useMutation(
    (accountId: number) => generateApiKey(accountId),
    {
      onError: () => showErrorSnackbar()
    }
  );

  return { mutateAsync, isLoading };
};
